import { ReactElement } from 'react'
import { ColorRepresentation } from 'three'
import { ImmutableVector3 } from '@modugen/ui-toolkit'
import SimpleTorusMesh from '../SimpleTorusMesh'

interface Props {
  position: ImmutableVector3
  color?: string | ColorRepresentation
  visible?: boolean
}

const DIAMETER = 0.65
const THICKNESS = 0.03

/**
 * Renders two torus rings at 45° to each other (in the XY plane) to form an X-like
 * support position indicator in the scene.
 */
const SupportPositionIndicatorMesh = ({
  position,
  color = 'red',
  visible = true,
}: Props): ReactElement => {
  return (
    <>
      <SimpleTorusMesh
        position={position}
        color={color}
        rotationX={(1 * Math.PI) / 4}
        rotationZ={0}
        visible={visible}
        diameter={DIAMETER}
        thickness={THICKNESS}
      />
      <SimpleTorusMesh
        position={position}
        color={color}
        rotationX={(3 * Math.PI) / 4}
        rotationZ={0}
        visible={visible}
        diameter={DIAMETER}
        thickness={THICKNESS}
      />
    </>
  )
}

export default SupportPositionIndicatorMesh
